import React, {useRef, useState} from "react";
import { Link } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Card,
    ListGroup,
    Modal,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUserGraduate,
    faFileAlt,
    faEnvelope,
    faExclamationCircle,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";
import InfoModal from "../../InfoModal/InfoModal";

const App7 = () => {
    // Состояние для модального окна
    const [legalizeModalShow, setlegalizeModalShow] = useState(false);
    const [svidModalShow, setSvidModalShow] = useState(false);
    const [certificateModalShow, setCertificateModalShow] = useState(false);


    const handleLegalizeModalClose = () => setlegalizeModalShow(false);
    const handleLegalizeModalShow = () => setlegalizeModalShow(true);

    const handleSvidModalClose = () => setSvidModalShow(false);
    const handleSvidModalShow = () => setSvidModalShow(true);

    const handleCertificateModalClose = () => setCertificateModalShow(false);
    const handleCertificateModalShow = () => setCertificateModalShow(true);

    const compatriotsModalTitle = "О категории «соотечественники»";

    const compatriotsModalDescription = (
        <>
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <Card.Title>

                        Категория «соотечественники»
                    </Card.Title>
                    <Card.Text>
                        К категории «соотечественники» относятся:
                    </Card.Text>
                    <ListGroup variant="flush">
                        <ListGroup.Item>
                            Лица, состоявшие в гражданстве СССР, проживающие в
                            государствах, входивших в состав СССР, получившие
                            гражданство этих государств или ставшие лицами без
                            гражданства.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            Выходцы (эмигранты) из Российского государства,
                            Российской республики, РСФСР, СССР и Российской
                            Федерации, имевшие соответствующую гражданскую
                            принадлежность и ставшие гражданами иностранного
                            государства либо имеющие вид на жительство или ставшие
                            лицами без гражданства.
                        </ListGroup.Item>
                        <ListGroup.Item>
                            Потомки лиц, принадлежащих к вышеуказанным группам.
                        </ListGroup.Item>
                    </ListGroup>
                </Card.Body>
            </Card>
        </>
    );

    const legalizeModalTitle = "Процедура легализации документов";
    const legalizeModalDescription = (
        <Card className="mb-4 shadow-sm">
            <Card.Body>
                <Card.Text>
                    Ознакомиться с процедурой легализации документов об
                    образовании и/или квалификации и получением свидетельства
                    о признании иностранного образования и/или квалификации вы
                    можете{" "}
                    <a
                        href="https://nic.gov.ru/ru/proc/nic/prepare"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        здесь
                    </a>
                </Card.Text>
            </Card.Body>
        </Card>
    );

    const svidModalTitle = "О признании иностранного образования";
    const svidModalDescription = (
        <Card className="mb-4 shadow-sm">
            <Card.Body>
                <Card.Text>
                    Признание иностранного образования не требуется, если
                    образование получено в Республике Беларусь, Республике
                    Казахстан, Кыргызской Республики, Республике Таджикистан,
                    Республике Азербайджан, Республике Армения, Республике
                    Молдова, Туркменистане, Украине (если образование получено
                    с 26.05.2000 по 21.12.2022), Республике Узбекистан (если
                    образование получено после 30 мая 2019 года), Республике
                    Абхазия (если образование получено после 11 января 2019
                    года), Республике Южная Осетия (если образование получено
                    после 4 мая 2018 года).
                </Card.Text>
            </Card.Body>
        </Card>
    );

    const certificateModalTitle = "Сертификат об окончании курсов";
    const certificateModalDescription = (
        <Card className="mb-4 shadow-sm">
            <Card.Body>
                <Card.Text>
                    Сертификат необходим для продления визы без выезда из
                    Российской Федерации для граждан визовых стран,
                    закончивших подготовительный факультет в текущем году и
                    находящихся на территории РФ.
                </Card.Text>
            </Card.Body>
        </Card>
    );


    const modalRef = useRef();
    const modalRef2 = useRef();
    const modalRef3 = useRef();
    const modalRef4 = useRef();
    return (
        <div className="DocumentLinksPage__content-container">
            <h2>
                Прием иностранных граждан
            </h2>
            <p>Иностранные граждане и лица без гражданства имеют право на получение высшего образования в Российской Федерации.</p>
            <Container className="mt-5">
                <Row>
                    <Col md={8} className="mx-auto">
                        {/* Блок о праве на получение образования */}
                        <Card className="mb-4 shadow-sm">
                            <Card.Body>
                                <Card.Title>
                                    <FontAwesomeIcon
                                        icon={faUserGraduate}
                                        className="me-2 text-primary"
                                    />
                                    Право на получение высшего образования
                                </Card.Title>
                                {/*<Card.Text>*/}
                                {/*    Иностранные граждане и лица без гражданства имеют право на*/}
                                {/*    получение высшего образования в Российской Федерации:*/}
                                {/*</Card.Text>*/}
                                <ListGroup variant="flush">
                                    <ListGroup.Item>
                                        <strong className="text-primary">
                                            БЕСПЛАТНО (за счет бюджетных ассигнований):
                                        </strong>
                                        <ul>
                                            <li>
                                                На общих основаниях граждане: Беларуси, Казахстана,
                                                Кыргызстана, Таджикистана.
                                            </li>
                                            <li>
                                                Имеющие вид на жительство в РФ граждане: Азербайджана,
                                                Армении, Молдовы, Узбекистана, Грузии, Туркменистана.
                                            </li>
                                            <li>
                                                Имеющие статус{" "}
                                                <Link to="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    modalRef.current.openModal();
                                                }}>
                                                    соотечественника
                                                </Link>.
                                            </li>
                                        </ul>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong className="text-primary">БЕСПЛАТНО:</strong> В
                                        рамках квоты, установленной Правительством РФ.
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong className="text-primary">
                                            С ОПЛАТОЙ ОБУЧЕНИЯ:
                                        </strong>{" "}
                                        За счет средств физических или юридических лиц.
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                        {/* модалка для соотечественников */}
                        <InfoModal
                            ref={modalRef}
                            title={compatriotsModalTitle}
                            description={compatriotsModalDescription}
                        />

                        {/* Блок о необходимых документах */}
                        <Card className="mb-4 shadow-sm">
                            <Card.Body>
                                <Card.Title>
                                    <FontAwesomeIcon
                                        icon={faFileAlt}
                                        className="me-2 text-primary"
                                    />
                                    Необходимые документы
                                </Card.Title>
                                <Card.Text>
                                    Для поступления в Гжельский государственный университет
                                    необходимы следующие документы:
                                </Card.Text>
                                <ListGroup variant="flush">
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />{" "}
                                        Документ, удостоверяющий личность (паспорт).
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />{" "}
                                        Документ об образовании с приложением,{" "}
                                        <Link to="#" onClick={(e) => {
                                            e.preventDefault();
                                            modalRef2.current.openModal();
                                        }}>
                                            легализованный в установленном порядке
                                        </Link>
                                        .
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />{" "}
                                        <Link to="#" onClick={(e) => {
                                            e.preventDefault();
                                            modalRef3.current.openModal();
                                        }}>
                                            Свидетельство
                                        </Link>{" "}
                                        о признании иностранного образования (при необходимости).
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />{" "}
                                        Документы, подтверждающие статус соотечественника (при
                                        наличии).
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />{" "}
                                        Документы, подтверждающие наличие вида на жительства в РФ
                                        (при наличии).
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="me-2 text-muted"
                                        />
                                        <Link to="#" onClick={(e) => {
                                            e.preventDefault();
                                            modalRef4.current.openModal();
                                        }}>
                                            Сертификат
                                        </Link>{" "}
                                        об окончании подготовительного факультета.
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>

                        <InfoModal
                            ref={modalRef2}
                            title={legalizeModalTitle}
                            description={legalizeModalDescription}
                        />

                        <InfoModal
                            ref={modalRef3}
                            title={svidModalTitle}
                            description={svidModalDescription}
                        />

                        <InfoModal
                            ref={modalRef4}
                            title={certificateModalTitle}
                            description={certificateModalDescription}
                        />

                        <Card className="mb-4 shadow-sm">
                            <Card.Body>
                                <Card.Title>
                                    <FontAwesomeIcon
                                        icon={faExclamationCircle}
                                        className="me-2 text-primary"
                                    />
                                    Важно
                                </Card.Title>
                                <Card.Text>
                                    Все документы на иностранных языках должны сопровождаться
                                    нотариально заверенными переводами на русский язык. В случае,
                                    если информация в паспорте и документе об образовании
                                    дублируется на русский язык, нотариальный перевод не
                                    требуется.
                                </Card.Text>
                                <Card.Text>
                                    На основании ФЗ-557 от 28.12.2024 иностранным гражданам
                                    предоставляется право приема на обучение по результатам
                                    внутренних вступительных испытаний только при отсутствии у них
                                    результатов ЕГЭ.
                                </Card.Text>
                                <Card.Text>
                                    Консультацию по вопросам поступления можно получить:
                                </Card.Text>
                                <ListGroup variant="flush">
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faEnvelope}
                                            className="me-2 text-info"
                                        />
                                        Электронная почта:{" "}
                                        <a
                                            href="mailto:omsgghpi@yandex.ru"
                                            className="text-decoration-none"
                                        >
                                            omsgghpi@yandex.ru
                                        </a>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            className="me-2 text-info"
                                        />
                                        Телефон:{" "}
                                        <a href="tel:+74964697505" className="text-decoration-none">
                                            +7 (496) 469-75-05
                                        </a>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default App7;
